import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  classList: [],
  statistics: {},
  subject: {},
  question: {},
  questionList: [],
  questionId: 0,
  questionCorrected: 0,
  questionIndex: null,
  action: "",
  isNext: true,
  isPrev: true
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};